import { render, staticRenderFns } from "./ItemEditRow.vue?vue&type=template&id=0c4618fa&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ItemEditRow.vue?vue&type=script&lang=ts"
export * from "./ItemEditRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4618fa",
  null
  
)

export default component.exports